<template>
	<div class="label-view" :style="_style">
		<slot />
	</div>
</template>

<script>
	import theme from '@/mixins/theme';

	export default {
		mixins: [theme],
		computed: {
			_style() {
				return {
					...this.theme.typography.body2,
					...{
						
					}
				};
			}
		}
	}
</script>

<style lang="scss" scoped>
	.label-view {

	}
</style>